/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const template = require('./recommend-list.tpl');
const communityMixin = require('../../community/communityMixin');
const methMinxin = require('../../community/methMixin');
require('./recommend-list.scss');

const communityPostList = {
	mixins:[communityMixin,methMinxin],
	template,

	data() {
		return {
			thItems: ["序号","类型","标题","内容","发布时间","话题状态","操作"],
			thItemSort:[
				{
					txt:'序号',
					isSort:0
				},
				{
					txt:'类型',
					isSort:0
				},
				{
					txt:'标题',
					isSort:0
				},
				{
					txt:'内容',
					isSort:0
				},
				{
					txt:'发布时间',
					isSort:1,
					keys:'browse',
					sortVal:3
				},
				{
					txt:'话题状态',
					isSort:0
				},
				{
					txt:'操作',
					isSort:0
				}
			],
			curtype:"",
			typeList:[
				{value:"",text:"选择类型"},
				{value:"1", text:"帖子"},
				{value:"2", text:"互动"},
				{value:"3", text:"活动"}
			],
			curKey: "",
			contentList:[
				{value:"topicKey", text:"标题"},
				{value:"content", text:"内容"}
			],
			url: apiPath.community.postList,
			

			pageInitCt: 1,
			
			placeItemTitle:"标题",
			placeItemContent:"请输入标题查询",
			
			hierarchyVal:1,
		
			sortTypeVal:"",
			sortList:[
				{value:"1", text:"正常排序"},
				{value:"2", text:"喜欢升序"},
				{value:"-2", text:"喜欢降序"},
				{value:"3", text:"评论升序"},
				{value:"-3", text:"评论降序"}
				
			],
			searchName:"topicKey",
			searchVal: "",
			searchList: [
				{value:"topicKey", text:"按话题关键字"},
				{value:"topicId", text:"按话题ID"},
				{value:"userName", text:"按用户名"},
				{value:"userId", text:"按用户ID"},
				{value:"userPho",text:"按用户手机号"}
			],

			hierarchyList:[
				{value:"",text:"全部帖"},
				{value:"1", text:"精华帖"},
				{value:"2", text:"置顶帖"}
			],
			timeVal:0,
			baseInfo:{},
			model:'post',
			queryOpt: {
				_index: 1
			},
			delRecommend: apiPath.community.delRecommend
		}
	},
	ready(){
		// this.getBrandFn();
	},
	methods:{
		searchData(){
			this.$refs.tableData.query({
				"startTime":this.calendar.items.startTime.value,
				"endTime":this.calendar.items.endTime.value,
				"searchName":this.searchName,
				"searchVal":this.searchVal,
				"_index":1,
				"type":this.curtype
			}).fetch();
		},
		sortTableCall(idx,stas){
			let _val = this.thItemSort[idx].sortVal;
			let _sortVal = stas==0? 1 : stas==1? _val :(0-_val);
			this.sortTypeVal = _sortVal;
			this.searchData();
		},
		remSetEssenceFn(id, idx){ //删除推荐
			let me = this;
			let args = {
			  'id':id,
			  'isRecommend': 0
			}
			ajaxHttp(this.delRecommend, {
				type: "post",
				data: args
			}).then((res)=> {
				tip(res.error || "删除成功");
				this.$refs.tableData.trItems.splice(idx,1);
            	this.$refs.tableData.resultData.total -= 1
			}).catch((res)=> {
				tip(res.message);
			})
		}
		
	},
	events:{
		[dropMenuEvent.menu.change](selecObj){
			console.log(selecObj);
			let queryName = selecObj.queryName;
			console.log(this.curKey);
			if(queryName === 'searchName'){
				this.searchName = selecObj.value;
				this.placeItem = selecObj.text;
				return;
			}
			if(queryName === 'curKey') {
				this.searchName = selecObj.value;
				this.placeItemContent = `请输入${selecObj.text}查询`;
				return;
			}
			this[queryName] = selecObj.value;
		},
		[inputBoxEvent.change](obj){
					this.searchVal = obj.value
		}
	},
	components:{
		pop
	}
}

module.exports = communityPostList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/common-recommend/recommend-list/recommend-list.js